var UIEvent;
(function (UIEvent) {
    UIEvent["PLAY_CLICK"] = "ui-events/play-click";
    UIEvent["PLAY_OVERLAY_CLICK"] = "ui-events/play-overlay-click";
    UIEvent["PAUSE_CLICK"] = "ui-events/pause-click";
    UIEvent["PROGRESS_CHANGE"] = "ui-events/progress-change";
    UIEvent["PROGRESS_DRAG_STARTED"] = "ui-events/progress-drag-started";
    UIEvent["PROGRESS_DRAG_ENDED"] = "ui-events/progress-drag-ended";
    UIEvent["PROGRESS_SYNC_BUTTON_MOUSE_ENTER"] = "ui-events/progress-sync-button-mouse-enter";
    UIEvent["PROGRESS_SYNC_BUTTON_MOUSE_LEAVE"] = "ui-events/progress-sync-button-mouse-leave";
    UIEvent["PROGRESS_USER_PREVIEWING_FRAME"] = "ui-events/progress-user-previewing-frame";
    UIEvent["VOLUME_CHANGE"] = "ui-events/volume-change";
    UIEvent["MUTE_CLICK"] = "ui-events/mute-click";
    UIEvent["UNMUTE_CLICK"] = "ui-events/unmute-click";
    UIEvent["ENTER_FULL_SCREEN_CLICK"] = "ui-events/enter-full-screen-click";
    UIEvent["EXIT_FULL_SCREEN_CLICK"] = "ui-events/exit-full-screen-click";
    UIEvent["ENTER_PICTURE_IN_PICTURE_CLICK"] = "ui-events/enter-picture-in-picture-click";
    UIEvent["EXIT_PICTURE_IN_PICTURE_CLICK"] = "ui-events/exit-picture-in-picture-click";
    // TODO=follow ENTITY_EVENT or ENTITY_EVENT format
    UIEvent["MOUSE_ENTER_ON_PLAYER"] = "ui-events/mouse-enter-on-player";
    UIEvent["MOUSE_MOVE_ON_PLAYER"] = "ui-events/mouse-move-on-player";
    UIEvent["MOUSE_LEAVE_ON_PLAYER"] = "ui-events/mouse-leave-on-player";
    UIEvent["FOCUS_ENTER_ON_PLAYER"] = "ui-events/focus-enter-on-player";
    UIEvent["FOCUS_LEAVE_ON_PLAYER"] = "ui-events/focus-leave-on-player";
    UIEvent["MAIN_BLOCK_HIDE"] = "ui-events/main-block-hide";
    UIEvent["MAIN_BLOCK_SHOW"] = "ui-events/main-block-show";
    UIEvent["LOADER_SHOW"] = "ui-events/loader-show";
    UIEvent["LOADER_HIDE"] = "ui-events/loader-hide";
    UIEvent["LOADING_COVER_SHOW"] = "ui-events/loading-cover-show";
    UIEvent["LOADING_COVER_HIDE"] = "ui-events/loading-cover-hide";
    UIEvent["TOGGLE_PLAYBACK_WITH_KEYBOARD"] = "ui-events/toggle-playback-with-keyboard";
    UIEvent["GO_BACKWARD_WITH_KEYBOARD"] = "ui-events/go-backward-with-keyboard";
    UIEvent["GO_FORWARD_WITH_KEYBOARD"] = "ui-events/go-forward-with-keyboard";
    UIEvent["INCREASE_VOLUME_WITH_KEYBOARD"] = "ui-events/increase-volume-with-keyboard";
    UIEvent["DECREASE_VOLUME_WITH_KEYBOARD"] = "ui-events/decrease-volume-with-keyboard";
    UIEvent["MUTE_WITH_KEYBOARD"] = "ui-events/mute-with-keyboard";
    UIEvent["UNMUTE_WITH_KEYBOARD"] = "ui-events/unmute-with-keyboard";
    UIEvent["HIDE_INTERACTION_INDICATOR"] = "ui-events/hide-interaction-indicator";
    UIEvent["PLAY_WITH_SCREEN_CLICK"] = "ui-events/play-with-screen-click";
    UIEvent["PAUSE_WITH_SCREEN_CLICK"] = "ui-events/pause-with-screen-click";
    UIEvent["ENTER_FULL_SCREEN_WITH_SCREEN_CLICK"] = "ui-events/enter-full-screen-with-screen-click";
    UIEvent["EXIT_FULL_SCREEN_WITH_SCREEN_CLICK"] = "ui-events/exit-full-screen-with-screen-click";
    UIEvent["CONTROL_DRAG_START"] = "ui-events/control-drag-start";
    UIEvent["CONTROL_DRAG_END"] = "ui-events/control-drag-end";
    UIEvent["KEYBOARD_KEYDOWN_INTERCEPTED"] = "ui-events/keyboard-keydown-intercepted";
    UIEvent["FULL_SCREEN_STATE_CHANGED"] = "ui-events/full-screen-state-changed";
    UIEvent["PICTURE_IN_PICTURE_STATUS_CHANGE"] = "ui-events/picture-in-picture-status-changed";
    UIEvent["RESIZE"] = "ui-events/resize";
})(UIEvent || (UIEvent = {}));
export default UIEvent;
//# sourceMappingURL=ui.js.map